(function($){

   

    // Initialize each block on page load (front end).
    $(document).ready(function(){
        var sliderHome = tns({
            container: '.slider-wrapper',
            items: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            nav: false,
            autoplayTimeout: 6000,
            speed: 3000,
            controlsText: ['<i class="far fa-chevron-left"></i>', '<i class="far fa-chevron-right"></i>'],
            mouseDrag: true
        });

         $('button[data-controls=next]').addClass('animate__fadeInRight slow toAnimate');
         $('button[data-controls=prev]').addClass('animate__fadeInLeft slow toAnimate');
    });



})(jQuery);